module.exports = __webpack_public_path__ + "img/logo-mini.5bedd6f7.svg";